import React, { useEffect, useState } from "react";
import { wpData } from "../data/wpAPI";

function Card({ content, featImgId, title }) {
  const [showModal, setModal] = useState(false);
  const [wpMedia, setWpMedia] = useState([]);

  // Fetch WP Media Data for the featured image
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rawMediaData = await wpData("media");
        setWpMedia(rawMediaData);
      } catch (error) {
        console.error("Error fetching WordPress Data:", error);
      }
    };
    fetchData();
  }, []);

  console.log("Media Data:", wpMedia);
  return (
    <>
      {showModal && (
        <dialog open>
          <div className="dialog-wrapper single-project">
            <button onClick={() => setModal(false)}>
              <span className="material-symbols-outlined">close</span>
            </button>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </dialog>
      )}

      <article>
        <div>
          <figure>
            {wpMedia.map(
              (image) =>
                image.id === featImgId && (
                  <img
                    key={image.id}
                    loading="lazy"
                    decoding="async"
                    width={image.media_details.width}
                    height={image.media_details.height}
                    src={image.source_url}
                    className={image.class_list.join(" ")}
                    alt={image.alt_text}
                  />
                ),
            )}
          </figure>
          <h4>{title}</h4>
        </div>
        <button className="full-btn" onClick={() => setModal(true)}>
          <span className="material-symbols-outlined screen-reader-text">open_in_full</span>
        </button>
      </article>
    </>
  );
}
export default Card;
